import { Component, Inject, NgZone, OnInit } from '@angular/core';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { CKEditorService } from 'src/app/includes/note-editor/ckeditor.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { WoundService } from 'src/app/services/wound.service';
import { lastValueFrom } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { PhrasesService } from 'src/app/includes/phrases/phrases.service';

@Component({
  selector: 'app-procedure-phrase-editor',
  templateUrl: './procedure-phrase-editor.component.html',
  styleUrls: ['./procedure-phrase-editor.component.css']
})
export class ProcedurePhraseEditorComponent implements OnInit {
  procedureDatasets: any = [];
  phrase_key: String;
  cke4Config;
  marker = '.';
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  constructor(
    public dialogRef: MatDialogRef<ProcedurePhraseEditorComponent>,
    @Inject(MAT_DIALOG_DATA) public procedure_data: ProcedurePhraseEditorComponent,
    private ckeditorService: CKEditorService,
    private _woundService: WoundService,
    private _toaster: ToastrService,
    private ngZone: NgZone,
    private phrasesService: PhrasesService,

  ) {
    if (procedure_data) {
      this.procedureDatasets = procedure_data.procedureDatasets;
      this.phrase_key = procedure_data.phrase_key;
      console.log(procedure_data);
    }
    this.cke4Config = {
      ...this.ckeditorService.getDefaultConfig(),
      editable: true
    };

    const extraPlugins = this.cke4Config.extraPlugins.split(',');
    this.cke4Config.extraPlugins = [...extraPlugins, 'selectdropdown', 'woundphrasesautocomplete'].join(',')
    // allow data attribute
    this.cke4Config.extraAllowedContent = 'p span[id][data-*](*)'
  }

  ngOnInit(): void {
    this.initPhrases();
    this.initGlobalScope();
  }
  initGlobalScope() {
    window['angularComponentReference'] = {
        component: this, zone: this.ngZone,
        componentDataMembers: {
            componentName: 'procedure-phrase-editor',
            phrases: this.phrasesService.castWoundPhrases
        },
        componentFunctions: {
            resolveSystemDefinedPhraseValue: (key, extra) => this.resolveSystemDefinedPhraseValue(key),
            
            onResolvePhraseStart: (phrase) => {
                // this._changeDetectorRefs.detectChanges();
            },
            onResolvePhraseEnd: (phrase, error) => {
                // this._changeDetectorRefs.detectChanges();
            }
        }
    };
}
initPhrases() {
  this.phrasesService.getWoundPhrases() //.subscribe();
}
 async resolveSystemDefinedPhraseValue(key) {
        return key;
        const keyWithoutMarker = key.substring(this.marker.length);
        // switch(keyWithoutMarker) {
        //     case 'phrase@dn':
        //         return '';
        //     default: 
        //         return {error: ''}
        // }
    }
  async saveProceduretemplate() {
    const infoToast = this._toaster.info('Updating Procedure Template', 'Please wait', { disableTimeOut: true });

    var details = {
      procedure_type_id: this.procedureDatasets._id,
      data: {
        template: this.procedureDatasets.template,
      }
    }
    const {status, data} = await lastValueFrom(this._woundService.updateProcedureDataset(
      this.procedureDatasets._id,this.procedureDatasets.category,this.procedureDatasets.size,
      this.procedureDatasets?.code_1, this.procedureDatasets?.code_2,this.procedureDatasets?.code_3,
      this.procedureDatasets?.template,
      this.procedureDatasets.is_deleted
    )) as any;
    if(status == 200) {
      this._toaster.clear(infoToast.toastId);
      this._toaster.success("Updated Procedure Template Successfully", "Success");
      this.dialogRef.close(this.procedureDatasets);
    }else{
      this._toaster.clear(infoToast.toastId);
      this._toaster.error("Something Went Wrong", "Failed");
    }
  }

  onReadyCkeditor(e) {
    const { editor } = e;
    this.ckeditorService.ckeditorRemoveTitle(editor);
  }
}
